import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertCircle, ChevronRight } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { formatCurrency } from './constants';

const PendingCommissionsCard = ({ pendingCommissions }) => {
  const navigate = useNavigate();

  if (pendingCommissions <= 0) return null;

  return (
    <Card 
      className="bg-white border border-slate-200 border-l-4 border-l-orange-500 shadow-sm hover:shadow-md transition-shadow duration-300 cursor-pointer"
      onClick={() => navigate('/comisiones')}
      data-testid="pending-commissions-card"
    >
      <CardContent className="p-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 rounded-xl bg-orange-50 flex items-center justify-center">
              <AlertCircle className="w-6 h-6 text-orange-500" strokeWidth={1.5} />
            </div>
            <div>
              <p className="text-sm text-slate-500 font-medium mb-1">Comisiones Pendientes del Mes</p>
              <p className="font-heading text-2xl font-bold text-orange-600">
                {formatCurrency(pendingCommissions)}
              </p>
            </div>
          </div>
          <Button 
            variant="ghost" 
            size="sm" 
            className="text-orange-600 hover:text-orange-700 hover:bg-orange-50"
          >
            Ver detalles
            <ChevronRight className="w-4 h-4 ml-1" />
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default PendingCommissionsCard;
